'use client';

import cn from 'classnames';

import UIResource from '@/components/UIResource';

import styles from './CookiePreferenceLabel.module.scss';

const CookiePreferenceLabel = ({ inFooter }: { inFooter?: boolean }) => {
  const openPreference = () => {
    if (typeof window.Osano !== 'undefined') {
      window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
    }
  };

  return (
    <div aria-hidden className={cn(styles.root, inFooter && styles.inFooter)}>
      <UIResource
        id="osano.lineItem"
        values={{
          'hyperlink label': (
            <button className={styles.link} onClick={openPreference}>
              <UIResource id="osano.lineItem.hyperlinkLabel" />
            </button>
          ),
        }}
      />
    </div>
  );
};

export default CookiePreferenceLabel;
